import React from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { inboxActions } from "_actions";
import BasicButton from "components/v2/common/BasicButton";
import StarIcon from "@mui/icons-material/Star";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function GeneratedResponse({
  draft,
  onUseSuggested,
  messageId,
}) {
  const dispatch = useDispatch();
  const generatedReply = useSelector((state) => state.inbox.generatedReply);
  const loadingGeneratedReply = useSelector(
    (state) => state.inbox.loadingGeneratedReply,
  );
  const text = generatedReply?.text || draft?.text;
  const sentiment = String(
    generatedReply?.sentiment || draft?.sentiment || "",
  ).toLowerCase();

  if (!text) {
    return null;
  }

  return (
    <Box sx={styles.wrapper}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={styles.tagTitle}>
          <StarIcon sx={{ fontSize: "10px" }} />
          AI Draft Copilot
        </Box>

        {sentiment && <Box sx={styles.tones}>tone: {sentiment}</Box>}
      </Box>

      <Box sx={styles.responseText}>{text}</Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
        }}
      >
        <Box>
          <BasicButton
            style={styles.greenBtn}
            label={"Use suggested response"}
            action={() => onUseSuggested?.(text)}
          />
        </Box>

        <Box>
          <BasicButton
            startIcon={<RefreshIcon style={{ fontSize: "16px" }} />}
            style={styles.outlineBtn}
            label={"Regenerate"}
            disabled={loadingGeneratedReply}
            action={() => dispatch(inboxActions.regenerateReply(messageId))}
          />
        </Box>
      </Box>
    </Box>
  );
}

const styles = {
  wrapper: {
    backgroundColor: "rgb(238, 245, 240)",
    padding: "12px",
    border: "1px solid rgb(207, 229, 215)",
    mb: 1,
    borderRadius: "12px",
  },
  tagTitle: {
    color: "rgb(47, 125, 79)",
    fontFamily: "FustatBold",
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  tones: {
    color: "rgb(107, 138, 118)",
    fontFamily: "FustatSemiBold",
    fontSize: "11px",
  },
  responseText: {
    color: "#28382d",
    fontFamily: "FustatRegular",
    fontSize: "14px",
    my: 1,
  },
  greenBtn: {
    fontSize: "13px",
    px: "16px",
    borderRadius: "9px",
    width: "max-content",
    height: "38px",
  },
  outlineBtn: {
    fontSize: "13px",
    px: "16px",
    height: "38px",
    borderRadius: "9px",
    border: "1px solid #d9d3c9",
    backgroundColor: "#ffffff",
    width: "max-content",
    color: "#003300",
    ":hover": {
      backgroundColor: "#ffffff",
      color: "#002900",
    },
  },
};
